import React from "react";
import { Draggable } from "components/drag-and-drop";
import { Brikk } from "components/Brikk";
import { SeeMoreButton } from "components/form-elements/buttons/SeeMoreButton";
import { Image } from "components/media/Image";
import { DoorEntryIcon } from "assets/icons/brikks/DoorEntryIcon";
import brikkPreviewSrc from "components/brikks/Office/Security/assets/security-brikk-preview.png";

export const Security = ({ position }) => {
  return (
    <>
      <Draggable position={position}>
        <Brikk disabled={true}>
          <Brikk.Header icon={<DoorEntryIcon />} heading="securityBrikk" />

          <Brikk.Content center>
            <Image src={brikkPreviewSrc} />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton disabled={true} brikkNameIntl="security" />
          </Brikk.Button>
        </Brikk>
      </Draggable>
    </>
  );
};
